module.exports = __webpack_public_path__ + "static/media/lungcancer.d1172020.svg";